import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputText from "../Components/InputText";
import PageNavigation from "../Components/PageNavigation";
import {AddressAutocomplete, AddressResult, PageAutocompleteState} from "../Components/AddressAutocomplete";
import Steps from "./steps";

export type AddressDetailsFields = {
    address_line_1: string;
    address_line_2: string;
    address_town: string;
    address_county: string;
    address_postcode: string;
}

export class AddressDetails extends React.Component<PageProps<AddressDetailsFields> & Partial<StepWizardChildProps>, PageState & PageAutocompleteState> {
    constructor(props: PageProps<AddressDetailsFields>) {
        super(props);

        this.state = {
            validation_triggered: false,
            address_autocomplete_manual_entry: false
        };
    }

    fill_search_result_fields(item: AddressResult) {
        this.props.update_value("address_line_1", item.Line1);
        this.props.update_value("address_town", item.Town);
        this.props.update_value("address_county", item.County);
        this.props.update_value("address_postcode", item.Postcode);

        if (item.Line2)
        {
            let address_line_2 = item.Line2;
            if (item.Line3)
            {
                address_line_2 += ", ";
                address_line_2 += item.Line3;
            }

            this.props.update_value("address_line_2", address_line_2);
        }
    }

    set_manual_entry_status(value: boolean) {
        this.setState(() => {
            return { address_autocomplete_manual_entry: value };
        });
    }

    triggerValidation()
    {
        const page_fields = ["address_line_1", "address_line_2", "address_town", "address_county", "address_postcode"];

        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>
            <div className="row">
                <div className="col-md-12">
                    <AddressAutocomplete
                        fill_result_fields={(item) => this.fill_search_result_fields(item)}
                        switch_manual_entry={(value) => this.set_manual_entry_status(value)}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <InputText
                        label="Address Line 1"
                        name="address_line_1"
                        value={this.props.form_values.address_line_1}
                        required={this.props.required.address_line_1}
                        validation_message="Please enter the first line of your address."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                        disabled={!this.state.address_autocomplete_manual_entry}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <InputText
                        label="Address Line 2"
                        name="address_line_2"
                        value={this.props.form_values.address_line_2}
                        required={this.props.required.address_line_2}
                        validation_message="Please enter the second line of your address."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                        disabled={!this.state.address_autocomplete_manual_entry}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <InputText
                        label="Town / City"
                        name="address_town"
                        value={this.props.form_values.address_town}
                        required={this.props.required.address_town}
                        validation_message="Please enter your town or city."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                        disabled={!this.state.address_autocomplete_manual_entry}
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        label="County"
                        name="address_county"
                        value={this.props.form_values.address_county}
                        required={this.props.required.address_county}
                        validation_message="Please enter your county."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                        disabled={!this.state.address_autocomplete_manual_entry}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <InputText
                        label="Postcode"
                        name="address_postcode"
                        value={this.props.form_values.address_postcode}
                        required={this.props.required.address_postcode}
                        validation_message="Please enter your postcode."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                        disabled={!this.state.address_autocomplete_manual_entry}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} onPrevious={() => this.goBack()}/>
                </div>
            </div>
        </div>;
    }
}